import { notification } from 'antd';

export const run = () => {
  notification.config({
    placement: 'bottomRight',
  });
};
